<template>
  <div 
    :style="{
      transition: `transform ${transitionTime} ease-in-out`,
      transform: `rotate(${rotated ? rotationStateTwo : rotationStateOne}deg)`
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Rotator',
  props: {
    rotated: Boolean,
    stateOne: {
      type: [Number, String],
      default: 0,
    },
    stateTwo: {
      type: [Number, String],
      default: 180,
    },
    transitionTime: {
      type: String,
      default: '0.15s'
    },
  },
  data () {
    return {
      rotationStateOne: 0,
      rotationStateTwo: 180,
    }
  },
  watch: {
    stateOne (newVal) {this.parseRotation(newVal, this.rotationStateOne)},
    stateTwo (newVal) {this.parseRotation(newVal, this.rotationStateTwo)}
  },
  mounted () {
    this.parseRotation(this.stateOne, 'rotationStateOne')
    this.parseRotation(this.stateTwo, 'rotationStateTwo')
  },
  methods: {
    parseRotation (value, destination) {
      let result = 0
      let copy = value?.toString()?.replace('deg', '')
      if (copy && !isNaN(copy)) result = copy
      this[destination] = result
    }
  }
}
</script>